'use strict';

import request from 'superagent';
import Promise from 'bluebird';
import qs from 'qs';

/*
 * Frost Web Client
 * Sends requests to this app's Controllers.
 *
 * Always returns a promise.
 */
export default {

	get: (url, params) => {
		// Build query string from params
		if (params) {
			url += '?' + qs.stringify(params);
		}
		return request.get(url);
	},

	del: (url, params) => {
		// Build query string from params
		if (params) {
			url += '?' + qs.stringify(params);
		}
		return request.del(url);
	},

	post: (url, data) => {
		return request
			.post(url)
			.send(data)
			.set('Content-Type', 'application/json');
	},

	put: (url, data) => {
		return request
			.put(url)
			.send(data)
			.set('Content-Type', 'application/json');
	},

	patch: (url, data) => {
		return request
			.patch(url)
			.send(data)
			.set('Content-Type', 'application/json');
	},

	head: (url, params) => {
		// Build query string from params
		if (params) {
			url += '?' + qs.stringify(params);
		}
		return request.head(url);
	},

}



// WEBPACK FOOTER //
// ./src/assets/js/lib/frost-web-client.js